export default __webpack_public_path__ + "static/media/chat-icon-bottom-nav-mobile.ca04819e.webp";